// 결과 화면 카드의 한눈에 보기 타일. 진행 기록(run)만 읽고 아무것도 바꾸지 않는다.
import { jobTitle } from './engine.js';
import { occupationOf, OCCUPATION_LABEL, todaySeries, todayValue } from './economy.js';
import { manwonText } from './lifeResult.js';

const MARRIAGE = { single: '미혼', married: '결혼 중', divorced: '이혼' };
const petsOf = (life) => life?.pet?.count ?? (life?.pet?.owned ? 1 : 0);

/** 맨 위 카드의 한눈에 보기 타일: 직업 · 순자산 · 가족 · 살림 */
export function buildKeyTiles(run) {
  const life = run.life, e = life?.economy, tiles = [];
  const occ = occupationOf(run.job);
  tiles.push({ key: 'job', label: '직업', value: run.job ? jobTitle(run.job) : '직업 없음', sub: run.job ? `${OCCUPATION_LABEL[occ] ?? ''} 직종 · ${run.job.name}` : '' });
  if (e?.series?.length) {
    const last = todaySeries(run).at(-1);
    tiles.push({ key: 'money', label: '마지막 순자산', value: manwonText(last.netWorth), sub: `총자산 ${manwonText(last.assets ?? todayValue(Math.max(0, e.cash) + e.homeValue, run, last.age))} − 부채 ${manwonText(last.debt ?? todayValue(e.mortgage + e.other, run, last.age))} · 2026년 돈 가치` });
  }
  if (life) {
    tiles.push({ key: 'family', label: '가족', value: `${MARRIAGE[life.marriage?.status] ?? '미혼'} · 자녀 ${life.children?.length ?? 0}명`, sub: life.marriage?.divorces ? `이혼 ${life.marriage.divorces}번` : '' });
    const pets = petsOf(life), homes = life.home?.count ?? 0;
    tiles.push({ key: 'home', label: '살림', value: `${homes ? `집 ${homes}채` : '집 없음'} · ${pets ? `반려동물 ${pets}마리` : '반려동물 없음'}`, sub: '' });
  }
  return tiles;
}
